import { createAPI } from "services/api/api";
import "../assets/css/masters-event.css";
import GradientBlock from "components/GradientBlock";
import { useContext, useEffect, useState } from "react";
import { WebSocketContext } from "components/page-components/PageWebsocketWrapper";

const MastersEvent = () => {
  const api = createAPI();
  const websocketContext = useContext(WebSocketContext);

  const [items, setItems] = useState([]);

  const getPredictionStatusClassName = (value) => {
    switch (value) {
      case "Resolved True":
        return "resolved";
      case "Resolved False":
        return "not-resolved";
      default:
        return "pending";
    }
  };

  const fetchMastersEventData = () => {
    api
      .get("/pool")
      .then((response) => {
        setItems(response.data.trigger_pools);
      })
      .catch((e) => {
        console.log("Error of getting Masters Event Pools");
      });
  };

  useEffect(() => {
    fetchMastersEventData();
  }, [websocketContext]);

  return (
    <article className="masters-event">
      <GradientBlock additionalClassName="gradient-block--masters">
        <h1 className="gradient-block__title">
          Masters Tournament Pool Predictions
        </h1>
      </GradientBlock>
      <main className={`masters-event__main ${!items.length || items === null ? 'masters-event__main--empty' : ''}`}>
        {
          !items.length || items === null ?
          <p className="masters-event__empty">No added triggers for this event yet.</p>
          :
          items.map(
            ({
              name,
              total_entries,
              is_open,
              total_pool_amount,
              user_identity_pool,
              total_identity_pool
            }) => {
              return (
                <section className="masters-event__item" key={name}>
                  <h2 className="masters-event__item-title">
                    {name}
                    <span>
                      {total_entries} {total_entries > 1 || total_entries === 0 ? "Entries" : "Entry"}
                    </span>
                  </h2>

                  <header className="masters-event__item-header">
                    <p>
                      Pool Status:
                      <span
                        className={`masters-event__item-status masters-event__item-status--${
                          is_open ? "open" : "closed"
                        }`}
                      >
                        {is_open ? "Open" : "Closed"}
                      </span>
                    </p>
                    <p>
                      Total Pool: <span>${total_pool_amount}</span>
                      <button className="masters-event__item-tooltip">
                        <p className="masters-event__item-tooltip-text">
                          The total value of prize cards used to make this
                          prediction. All players whose prediction resolves true
                          receive a pro-rata share of the value of prize cards
                          used in predictions which resolved false.
                        </p>
                      </button>
                    </p>
                  </header>

                  <div className="masters-event__item-table">
                    <ul className="masters-event__item-table-row masters-event__item-table-row--head">
                      <li className="masters-event__item-table-col masters-event__item-table-col1">
                        Your Identities
                      </li>
                      <li className="masters-event__item-table-col masters-event__item-table-col2">
                        Prediction Status
                      </li>
                      <li className="masters-event__item-table-col masters-event__item-table-col3">
                        Prize Card
                      </li>
                      <li className="masters-event__item-table-col masters-event__item-table-col4">
                        Projected Pool Bonus
                        <button className="masters-event__item-tooltip">
                          <p className="masters-event__item-tooltip-text">
                            Your projected share of the Total Pool if your
                            prediction resolves true. Payout amount is in addition
                            to the value of the prize card in your prediction.
                          </p>
                        </button>
                      </li>
                    </ul>
                    {
                      !user_identity_pool.length || user_identity_pool === null ?
                      <p className="masters-event__empty">You haven't made any predictions for this trigger yet.</p>
                      :
                      user_identity_pool.map((user_identity, index) => {

                        const totalIdentityFind = total_identity_pool.find((identity) => identity.name === user_identity.name);

                        const userSubtotal = (total_pool_amount - totalIdentityFind.subtotal_amount);

                        const usersPercent = (user_identity.player_amount / totalIdentityFind.subtotal_amount);

                        const potentialPayout = userSubtotal * usersPercent;

                        return (
                          <ul className="masters-event__item-table-row" key={index}>
                            <li className="masters-event__item-table-col masters-event__item-table-col1">
                              {user_identity.name}
                            </li>
                            <li className="masters-event__item-table-col masters-event__item-table-col2">
                              <span
                                className={`masters-event__item-status masters-event__item-status--${getPredictionStatusClassName(
                                  user_identity.status
                                )}`}
                              >
                                {user_identity.status}
                              </span>
                            </li>
                            <li className="masters-event__item-table-col masters-event__item-table-col3">
                              ${user_identity.player_amount}
                            </li>
                            <li className="masters-event__item-table-col masters-event__item-table-col4">
                              ${potentialPayout.toFixed(2)} est.
                            </li>
                          </ul>
                        );
                      })
                    }
                  </div>
                </section>
              );
            }
          )
        }
      </main>
    </article>
  );
};

export default MastersEvent;
